import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config';
import { candadoDeLaPestana } from './candadoDeLaPestana';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
    // Candado de esta pestaña, no el de `navigator.locks` (compartido entre pestañas): otra
    // pestaña de Atlas congelada lo dejaba tomado y el retorno de Google no entraba nunca.
    // ADR-2026-10-15-el-login-con-google-no-espera-a-otras-pestanas.
    lock: candadoDeLaPestana,
  },
});
